var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    ref: "container3d",
    staticClass: "position-relative w-100 h-100"
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }